import { useContext, useEffect, useMemo, useState } from 'react';
import { Flex, Grid, Layout, Result, theme } from 'antd';
import { Footer } from 'antd/es/layout/layout';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { Acesso } from '../Acesso';
import { SessaoARContext } from '../../Contexts/SessaoContext';
import { EnumTipoUsuario } from '../../../Models/Domain/AreaRestrita/Sessao';
import { LayoutHeader, MenuApp } from '../../Components/LayoutHeader';
import { ComParametrosDaSessao } from './ParametrosDaSessao';

import { MeusDados } from "../Paginas/MeusDados";
import { MinhasViagens } from "../Paginas/MinhasViagens";
import PessoaBloqueioScreen from '../Erro/PessoaBloqueioScreen';

export function MasterPage(props: { temaEscuro: boolean, setTemaEscuro: (tema: boolean) => void }) {
    const SessaoAR = useContext(SessaoARContext);

    const [collapsed, setCollapsed] = useState(false);
    const breakpoints = Grid.useBreakpoint();
    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();

    const usuarioAutenticado = SessaoAR?.sessao?.token != undefined && SessaoAR?.sessao?.usuario != undefined;
    const tipoDeUsuario = SessaoAR?.sessao?.tipoDeUsuario;

    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const rotas = useMemo(() => {
        const r = [
            <Route key="home" index element={<MinhasViagens/>} />
        ];

        if (tipoDeUsuario === EnumTipoUsuario.Responsavel) {
            r.push(
                <Route
                    key="dados-responsavel"
                    path="meus-dados/*" 
                    element={<MeusDados/>}
                />,

                <Route
                    key="viagens-responsavel"
                    path="viagens/*"
                    element={<MinhasViagens/>}
                />,

                <Route key="senhaViagem" path="/senhaViagem" element={<div>Senha Viagem</div>} />,
                <Route key="fichaSaude" path="/fichaSaude" element={<div>Ficha de Saúde</div>} />,
                <Route key="pagamento" path="/pagamento" element={<div>Pagamento</div>} />,
                <Route key="conclusao" path="/conclusao" element={<div>Conclusao</div>} />,
                <Route key="autenticacao" path='/autenticacao' element={<Navigate to={"/"}/>} />,
            );
        } else if (tipoDeUsuario === EnumTipoUsuario.Escola) {
            r.push(
                <Route key="dados-escola" path="meus-dados/*" element={<MeusDados/>} />,
                <Route key="viagens-escola" path="viagens/*" element={<MinhasViagens/>} />,
            );
        }

        r.push(<Route key="pessoa-bloqueio" path="status-bloqueado" element={<PessoaBloqueioScreen />} />);
        r.push(<Route key="notfound" path="*" element={<Result status={"404"} title="Página não encontrada"/>} />);

        return r;
    }, [tipoDeUsuario]);

    return (
        <Layout hasSider>
            {
                !breakpoints.lg &&
                <Layout.Sider
                    breakpoint="lg"
                    collapsedWidth={"0"}
                    trigger={null}
                    collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}
                    width={200} style={{ overflow: 'auto', height: '100vh', position: 'fixed', left: 0, top: 62, bottom: 0, zIndex: 4 }}
                >
                    <MenuApp collapsed={collapsed} setCollapsed={setCollapsed} />
                </Layout.Sider>
            }

            <Layout style={{ minHeight: "100vh" }}>
                {usuarioAutenticado == false ?
                    <Flex style={{ height: "100%" }} justify='center' align='center'>
                        <Routes>
                            <Route path='/autenticacao/*' element={<Acesso />} />
                            <Route path='*' element={<Navigate to="/autenticacao" />} />
                        </Routes>
                    </Flex>
                    :
                    <ComParametrosDaSessao>
                        <LayoutHeader collapsed={collapsed} setCollapsed={setCollapsed} temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
                        <Layout.Content style={{ padding: 0, margin: 0 }} >
                            <Routes>
                                {rotas}
                            </Routes>
                        </Layout.Content>
                    </ComParametrosDaSessao>
                }

                {usuarioAutenticado &&
                    <Footer style={{ textAlign: 'center', bottom: 0, width: '100%', padding: 10, marginTop: "1rem" }}>
                        © {new Date().getFullYear()} <a href='https://accessbrasil.net.br/' target='_blank' rel="noreferrer">AccessBrasil</a> | Anchor Com. Serv. Informática Ltda. | Todos os direitos reservados.
                    </Footer>
                }

            </Layout>
        </Layout>

    );
}
